/* The functions that used to live in the component that talked with the mutations
* Anything connected to the redux state has a function here */
import { destroyTicketNumber } from './graphql/ticketNumberDelete';
import { updateMissingTicketDetails } from './graphql/updateMissingTicketDetailsMutation';

export const types = {
  SELECT_TICKET_NUMBER: 'ticketNumberStatus/SELECT_TICKET_NUMBER',
};


export const setTicketNumberObject = (ticketNumberObject) => {
  return {
    type: types.SELECT_TICKET_NUMBER,
    ticketNumberObject,
  };
};

export const confirmDeleteTicketNumber = (ticketNumberId) => {
  return async (dispatch, getState, { client }) => {
    await destroyTicketNumber(client, ticketNumberId);
    dispatch(setTicketNumberObject({}));
  };
};

export const updateMissingTicketDetailsThunk = (detailsObject, onHide) => {
  return async (dispatch, getState, { client }) => {
    await updateMissingTicketDetails(client, detailsObject);
    onHide();
  };
};
